import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Service Catalog list (CLAUDE.md §2.3),
 * mirroring the CRM/HRM list stores. Search/category/is_active filters live in
 * URL-bound page state and stay out of the store — those are server-driven query
 * params, not durable user prefs.
 */
export type ServicesViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const SERVICES_VIEW_MODES: ServicesViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface ServicesUiState {
  view: ServicesViewMode;
  setView: (view: ServicesViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-base_rate`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useServicesUi = create<ServicesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.services:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
